import { vcardMicrositeAPIService } from '~/api/microsites/vcard-plus';

export const downloadContacts = async (id?: number) => {
  if (!id) return;

  const response = await vcardMicrositeAPIService.addContact(id);
  const blob = new Blob([response.data], { type: 'text/vcard' });

  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = 'contact.vcf';

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(link.href);
};
